import { useQuery } from '@tanstack/react-query'
import { listStructures } from '../services/structures'
import { SPECIAL_SCHEMA } from '../lib/specialSchema'
import { queryKeys } from '../lib/queryKeys'
import type { StructureEntry } from '../types/structures'

interface UseStructuresResult {
  structures: StructureEntry[]
  isLoading: boolean
}

export function useStructures(schemaName: string): UseStructuresResult {
  const enabled = !!schemaName && schemaName !== SPECIAL_SCHEMA

  const { data, isLoading } = useQuery({
    queryKey: queryKeys.structures.list(schemaName),
    queryFn: () => listStructures(schemaName),
    enabled,
    staleTime: Infinity,
  })

  if (!enabled) {
    return { structures: [], isLoading: false }
  }

  return {
    structures: data ?? [],
    isLoading,
  }
}
